document.addEventListener('DOMContentLoaded', function() {
    // Page has loaded and theme assets are ready
        // console.log("Page has loaded and theme assets are ready");

        // $('.recommendation-modal__form').submit(function (evt) {
        //     evt.preventDefault();
        // });

        function summ(form){
            setTimeout(() => {
                form[0].submit();
            }, 1000);
        }

        function local_max(){
            // console.log("mx");

                var form =  document.getElementsByClassName("recommendation-modal__form");

                if (form[0] !== undefined){
                form[0].style.display = "block";


                form[0].addEventListener("submit", function(evt) {
                    evt.preventDefault();

                    var code = "";
                    var inp = form[0].querySelector('input[name="country_code"]');
                    var sel = form[0].querySelector('select[name="country_code"]');

                    if(inp){
                         code = inp.value;
                    }else if(sel){
                         code = sel.value;
                    }else{
                        code = "de";
                    }

                     var final_code = code.toLowerCase();

                     if (final_code != "de" && final_code != "nl"){
                        final_code = "de";
                     }
                    //  console.log(final_code);


                    //  document.getElementById("weglot-language-"+final_code).click();

                     summ(form);

                    //  var close =  document.getElementsByClassName("recommendation-modal__close-button");
                    //  close[0].click();
                 });
                }



        }


        setInterval(function () {
            local_max();
            var but =  document.getElementsByClassName("recommendation-modal__button--minimal");
            if (but[0] !== undefined){
                but[0].addEventListener("click", function() {
                    local_max()
                });
            }
        }, 1000);

       function swatcherEnable() {
                // get selected color images
                
                let getImages = (swatch) => {
                    
                    var productImages = window.productImages[`product_${swatch.dataset.productId}`],
                        imageUrl = '',
                        imageUrlPrew= '',
                        hoverImageUrl = '';
                    if(!productImages) {
                        
                        window.productImagesV = {};
                        var recommendationsContainer = document.querySelector(".product-recommendations");

                        if (recommendationsContainer) {
                        var recommendedSwitches = recommendationsContainer.querySelectorAll(".recomended-switch");
                        // console.log(recommendedSwitches)
                        recommendedSwitches.forEach(function(element) {
                            
                            var productId = element.getAttribute("data-productiid");
                            var productData = element.getAttribute("data-productvv");
                            window.productImagesV[productId] = window.productImagesV[productId] || [];
                            if (productId && productData) {
                                stringValue = productData.replace(/'/g, '"');
                                var objectValue = JSON.parse(stringValue);
                                window.productImagesV[productId].push(objectValue);
                            }
                        });

                        
                        }
                        productImages = window.productImagesV[`product_${swatch.dataset.productId}`]

                    }
                    
                    if(productImages && productImages.length > 0){
                        for(let i = 0, l = productImages.length; i < l; i++){
                            // console.log(productImages[i])
                            //  console.log(productImages[i]['image_name'])
                            //  console.log(swatch.dataset.variantSku)
                            //  console.log(swatch.dataset.variantSku.includes(productImages[i]['image_name']))
                            if(swatch.dataset.variantSku.includes(productImages[i]['image_name'])){
                                imageUrl = productImages[i]['image_url'];
                                if(productImages[i + 1]) hoverImageUrl = productImages[i + 1]['image_url'];
                                break;
                            }
                        }
                        // for(let i = 0, l = productImages.length; i < l; i++){
                        //     if(swatch.dataset.variantSku.includes(productImages[i]['image_name'])){
                        //         let urlThumb = productImages[i]['image_name']+"_1";
                        //         if(productImages[i]['image_url'].includes(urlThumb)){
                        //             imageUrlPrew = productImages[i]['image_url'];
                        //             console.log(imageUrlPrew)
                        //             break;
                        //         }  
                        //     }
                        // }
                    }
                    swatch.dataset.colorimg = imageUrl;
                    swatch.dataset.colorimgsecond= hoverImageUrl;
                    swatch.dataset.colorimgThumb= imageUrlPrew;
                    // console.log("swatch")

                    return {
                        imageUrl,
                        hoverImageUrl
                    }
                };
                // collection color swatchers
                let gridProductSwatchers = document.querySelectorAll('.grid-product__colors .color-swatch');
                if(gridProductSwatchers){
                    gridProductSwatchers.forEach(swatch => {
                        getImages(swatch);
                        
                        swatch.addEventListener('click', () => {
                            
                            swatch.closest('.grid__item').getElementsByClassName('grid-product__link')[0].setAttribute('href',swatch.getAttribute('data-url'))
                            let { imageUrl, hoverImageUrl } = getImages(swatch);
                            setImages(swatch, imageUrl, hoverImageUrl);
                        })
                        
                    })
                    
                }
                // set selected color images
                let setImages = (swatch, imageUrl, hoverImageUrl) => {
                    let productWrapper = document.querySelector(`[data-product-id='${swatch.dataset.productId}']`);
                    if(productWrapper){
                        let firstImage = productWrapper.querySelector('img.grid-product__image'),
                            secondImage = productWrapper.querySelector('.grid-product__secondary-image img');
                        if(firstImage){
                            firstImage.removeAttribute('srcset');
                            firstImage.setAttribute('src', imageUrl);
                        }
                        if(secondImage && hoverImageUrl){
                            secondImage.removeAttribute('srcset');
                            secondImage.setAttribute('src', hoverImageUrl);
                        }
                        
                    }
                };
       }
       swatcherEnable()
       
       var observer = new MutationObserver(function(mutationsList, observer) {
            mutationsList.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    
                    if (node.nodeType === 1 && node.classList.contains('product-recommendations')) {
                        var colorSwatches = document.querySelectorAll('.color-swatch');
                        swatcherEnable()
                        
                        observer.disconnect();
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
    


    class LocalizationForm extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('ul'),
          };
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      
          this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
        }
      
        hidePanel() {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
          document.getElementById('LanguageList1').classList.remove("open");
        }
      
        onContainerKeyUp(event) {
          if (event.code.toUpperCase() !== 'ESCAPE') return;
      
          this.hidePanel();
          this.elements.button.focus();
        }
      
        onItemClick(event) {
          event.preventDefault();
          const form = this.querySelector('form');
          this.elements.input.value = event.currentTarget.dataset.value;
          if (form) form.submit();
        }
      
        openSelector() {
          this.elements.button.focus();
          this.elements.panel.toggleAttribute('hidden');
          this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
          if ( !document.getElementById('LanguageList1').classList.contains('open')) {
            document.getElementById('LanguageList1').classList.add("open");
          } else {
            document.getElementById('LanguageList1').classList.remove("open");
          }
        }
      
        closeSelector(event) {
          const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
          if (event.relatedTarget === null || shouldClose) {
            this.hidePanel();
          }
        }
      }
      
      customElements.define('localization-form', LocalizationForm);
    //   console.log('custom //// end')



var checkExist = setInterval(function() { 
  if (document.querySelector('#insta-feed h2')) { 
    if (Shopify.locale === 'en') document.querySelector('#insta-feed h2').firstChild.nodeValue = 'Follow us on Instagram';
    else if (Shopify.locale === 'nl') document.querySelector('#insta-feed h2').firstChild.nodeValue = 'VOLG ONS OP INSTAGRAM'; 
clearInterval(checkExist);}}, 100);

document.addEventListener('DOMContentLoaded', function() {
    const targetNode = document.querySelector('.review-height .collapsible-content__inner');
    const reviewHeightElement = document.querySelector('.review-height');
    let intervalCounter = 0;
    const maxIntervals = 7;

    if (!targetNode || !reviewHeightElement) {
        console.error('Target node or review height element not found.');
        return;
    }


    const intervalId = setInterval(function() {
        const currentHeight = targetNode.offsetHeight;
        console.log('HEIGHT', currentHeight);
        if (currentHeight > 40) {
            reviewHeightElement.style.height = 'auto';
            reviewHeightElement.style.opacity = '1';
            clearInterval(intervalId);
        } else {
            reviewHeightElement.style.height = '0';
            reviewHeightElement.style.opacity = '0';
        }
        
        intervalCounter++;
        if (intervalCounter >= maxIntervals) {
            clearInterval(intervalId);
        }
    }, 1000);
document.addEventListener('click', function(event) {
        if (event.target.tagName.toLowerCase() === 'etrusted-widget') {
            
            const widgetHeight = event.target.offsetHeight;
            console.log('Clicked on etrusted-widget:', widgetHeight);
            const parentCollapsible = event.target.closest('.collapsible-content');
            if (parentCollapsible) {
              parentCollapsible.style.height = `${widgetHeight}px`;
            }
          }
    });
});



document.querySelectorAll('.icon-container').forEach(container => {
  const tooltip = container.querySelector('.custom-tooltip');
  const icon = container.querySelector('img, svg');
  const iconsWrapper = document.querySelector('.wrp-icons'); // Der Haupt-Container

  if (!tooltip || !icon || !iconsWrapper) {
    console.warn("⚠️ Tooltip oder Icon nicht gefunden!", container);
    return;
  }

  // Tooltip global im `.wrp-icons` Container platzieren
  iconsWrapper.appendChild(tooltip);

  const adjustTooltipPosition = () => {
    requestAnimationFrame(() => {
      const iconRect = icon.getBoundingClientRect();
      const iconsWrapperRect = iconsWrapper.getBoundingClientRect();
      const tooltipHeight = tooltip.offsetHeight;
      const tooltipWidth = tooltip.offsetWidth;
      const padding = 10; // Sicherheitsabstand

      console.log("ICON-Position:", iconRect);
      console.log("TOOLTIP Vorher:", tooltip.getBoundingClientRect());

      // 🎯 Standardmäßig über dem Icon
      let newTop = iconRect.top - iconsWrapperRect.top - tooltipHeight - 8;
      let newLeft = iconRect.left - iconsWrapperRect.left + (iconRect.width / 2);

      // Falls das Tooltip OBEN aus dem Bildschirm ragt, setzen wir es UNTEN
      if (newTop < padding) {
        newTop = iconRect.bottom - iconsWrapperRect.top + 8;
      }

      // **Horizontale Begrenzung innerhalb `.wrp-icons`**
      if (newLeft + tooltipWidth / 2 > iconsWrapperRect.width - padding) {
        newLeft = iconsWrapperRect.width - tooltipWidth - padding;
        tooltip.classList.add("align-right");
        tooltip.classList.remove("align-left");
      } 
      else if (newLeft - tooltipWidth / 2 < padding) {
        newLeft = padding + tooltipWidth / 2;
        tooltip.classList.add("align-left");
        tooltip.classList.remove("align-right");
      } 
      else {
        tooltip.classList.remove("align-left", "align-right");
      }

      // Tooltip-Position setzen
      tooltip.style.position = "absolute";
      tooltip.style.top = `${newTop}px`;  // Vertikale Position bleibt frei!
      tooltip.style.left = `${newLeft}px`;
      tooltip.style.transform = "translateX(-50%)";
      tooltip.style.visibility = "visible";
      tooltip.style.opacity = "1";

      console.log("TOOLTIP Nachher:", tooltip.getBoundingClientRect());
    });
  };

  icon.addEventListener("mouseenter", adjustTooltipPosition);
  icon.addEventListener("mouseleave", () => {
    tooltip.style.visibility = "hidden";
    tooltip.style.opacity = "0";
  });

  icon.addEventListener("touchstart", adjustTooltipPosition);
  icon.addEventListener("touchend", () => {
    tooltip.style.visibility = "hidden";
    tooltip.style.opacity = "0";
  });
});